

import React, { useState, useEffect } from 'react';
import { Button, Alert } from "react-bootstrap";
import Popup from 'reactjs-popup';
import moment from 'moment';

import PropTypes from "prop-types";


Permesso.propTypes = {
    value: PropTypes.object,
    annulla: PropTypes.func,
    conferma: PropTypes.func,
    open: PropTypes.bool,
    message: PropTypes.array
}

function Permesso({ value, annulla, conferma, open, message }) {

    const [oraInizio, setOraInizio] = useState(value ? value.inizio : "");
    const [oraFine, setOraFine] = useState("");
    const [giorno, setGiorno] = useState("");


    useEffect(() => {
        clear();
        setOraInizio(value ? moment(value.inizio).format('HH:mm') : "")
        setOraFine(value ? moment(value.fine).format('HH:mm') : "")
        setGiorno(value ? moment(value.inizio).format('YYYY-MM-DD')  : "")
    }, [value, open])


    const clear = () => {
        setGiorno("");
        setOraFine("");
        setOraInizio("");
    }

    const confermaPermesso = () => {
        const inizio = combineDateAndTime(oraInizio, giorno);
        const fine = combineDateAndTime(oraFine, giorno);
        if (!oraFine || !oraInizio || !giorno) {
            alert("Attenzione! Impostare tutti i campi")
        } else if (inizio >= fine) {
            alert("Attenzione! La data di inizio periodo è successiva o uguale a quella di fine periodo")
        } else {
            const id = value ? value.id : "";
            conferma(moment(inizio).format('YYYY-MM-DD HH:mm'), moment(fine).format('YYYY-MM-DD HH:mm'), id);
        }
    }

    const combineDateAndTime = (timeStr, dateStr) => {
        const date = new Date(dateStr);
        const [hours, minutes] = timeStr.split(':').map(Number); 
        date.setHours(hours, minutes, 0, 0);   
        return date;
    };
    
    const annullaPermesso = () => {
        clear();
        annulla();
    }

    return (
        <Popup closeOnDocumentClick={false} open={open}>
            <div>
                {
                    message && message.map((data, key) => (
                        <Alert variant={data.tipo} id="message" key={key}>
                            {data.descrizione}
                        </Alert>
                    ))
                }
                <div className="formGroup" id="permesso">
                    <div className="date-container">
                        <div className="date-field">
                            <label htmlFor="giorno" className="inEvidenza">data</label>
                            <input
                                className='form-control'
                                id="giorno"
                                type="date"
                                value={giorno}
                                onChange={(event) => {
                                    setGiorno(event.target.value);
                                }}
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="orainizio" className="inEvidenza">ora inizio</label>
                            <input
                                className='form-control'
                                id="orainizio"
                                type="time"
                                value={oraInizio}
                                onChange={(event) => {
                                    setOraInizio(event.target.value);
                                }}
                            />
                        </div>
                        <div className="date-field">
                            <label htmlFor="orafine" className="inEvidenza">ora fine</label>
                            <input
                                className='form-control'
                                id="orafine"
                                type="time"
                                value={oraFine}
                                onChange={(event) => {
                                    setOraFine(event.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div id="action" className="action">
                        <Button className="btnGenerale" variant="flat" size="sm" id="annulla"
                            onClick={() => { annullaPermesso() }}>annulla</Button>
                        <Button className="btnGenerale" variant="flat" size="sm" id="conferma"
                            onClick={() => { confermaPermesso() }}>conferma</Button>
                    </div>
                </div>
            </div>
        </Popup>)
}


export default Permesso;